import React, { Fragment, Component } from 'react'
import {
    Row, Col,Button, Label,Table
} from "reactstrap"
import classnames from 'classnames'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"
import CustomSelect from '../../../../../helpers/ui/CustomSelect'
import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'

import IndexBloc from '../../Index/Blocs/IndexBloc'
import UpdateBloc from '../Blocs/UpdateBloc'

class TugasComponent extends Component {

    updateBloc = new UpdateBloc()
    indexBloc = new IndexBloc()
    source
    timer
    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            detailTugas: [
                {
                    tugas: '',
                }
            ],
            kompetensilist: [
                {
                    kompetensiuuid: '',
                    kompetensiname:'',
                }
            ],
            kompetensilevel: [
                {
                    level: '',
                    levelname:'',
                }
            ],
            list: [],
            dataForm: {},
            isLoading: 0,
        }
    }

    addTask = () => {
        let count = this.state.detailTugas.length;
        this.setState({
            detailTugas: [
                ...this.state.detailTugas,
                {
                    tugas : count == 0 ? (count+1) : ''
                }
            ]
        })

        console.log(this.state.detailTugas)
    }

    delStankom = (data) => {
        let count = this.state.detailTugas.length-1;
        this.setState({
            detailTugas: [
                ...this.state.detailTugas.filter((val) => val!=data)
                
                // (count-1)
            ]
        })
    }

    reformatTugas = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["tugas"] = data.task_description;
          return newObj;
        });
    }
    reformatLevel = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = `Level-${data.level_no}-${data.level_name}`;
          newObj["value"] = data.level_id;
      
          return newObj;
        });
    }

    reformatOptions = function(raw, label, value) {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
      };

    handleChangeInputTask = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.detailTugas];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.desc = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({detailTugas : items});
    }

    toggle = tab => {
        if(this.state.activeTab !== tab) this.setState({activeTab:tab});
    }

    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadDetail = async () => { //load jabatan info
        const query = {
            uuid: this.props.uuid
        }

        await this.updateBloc.fetchPositionInfo(query)
    }

    loadDetailTugas = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.updateBloc.fetchPositionTask(query)
    }
    loadKompetensi = async () => {
        const query = {
            uuid: this.props.uuid,
            type: 1
        }

        await this.updateBloc.fetchKompetensiList(query)
    }
    loadInfoJabatan = async () => {
        const query = {
            uuid: this.props.uuid,
            // type: 1
        }

        await this.updateBloc.fetchPositionInfo(query)
    }

    handlerOnSubmitTugas = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                position_uuid: this.props.uuid,
                ...values
            },
            confirm: true
        })
    }

    componentDidMount() {
        this.loadDetail()
        this.loadInfoJabatan()
        this.loadDetailTugas()
        
    //   console.log(this.props.uuid)
        // this.updateBloc.detailTugasChannel.subscribe((result) => {
        //     switch (result.status) {
        //         case apiResponse.COMPLETED:
        //             let resp = result.data.response;
        //             console.log('---------')
        //             console.log(resp)

        //             if (resp!=null && resp.length > 0){
        //                     this.setState({ detail: resp })
        //             }

        //             break;
        //         case apiResponse.ERROR:
        //             break;
        //         default:
        //             break;
        //     }
        // })
        this.updateBloc.detailTugasChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log('response')
                        console.log(response)
                        if (response.length > 0) {
                            this.setState({ detailTugas: this.reformatTugas(response) })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.infoJabatanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let resp = result.data.response;

                    if (resp!=null && resp.length > 0){
                        this.setState({ detail: result.data.response })
                    }

                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
        this.updateBloc.kompetensiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let resp = result.data.response;

                    // console.log(resp)

                    this.setState({
                        kompetensilist : this.reformatOptions(
                            resp, 
                            'competence_name',
                            'competence_uuid'
                        )
                    })

                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
        this.indexBloc.updateChannel?.unsubscribe()
        this.updateBloc.positionInfoChannel?.unsubscribe()
        this.updateBloc.detailTugasChannel?.unsubscribe()
    }

    render() {
        const { detail, list } = this.state
        return (
            <Fragment>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmitTugas(e, values)}
                >
                    <Row className="mb-12">
                        <AvField
                            name="tipe"
                            type="hidden"
                            id="tipe"
                            value="1"
                        />
                        <Table className="table-bordered">
                            <thead className="bg-default" style={{background:'lavender'}}>
                                <tr>
                                    <th>Uraian Tugas Kerja</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                    {
                                this.state.detailTugas.map((data, index) => {
                                    return (
                                        <div className="row">
                                            <div className="col-md-11">
                                            
                                            <AvField
                                                name={`tugas[${index}]`}
                                                placeholder={`Masukkan Uraian Tugas-${(index+1)}`}
                                                type="text"
                                                errorMessage="Masukkan Uraian Tugas"
                                                className="form-control mb-2"
                                                onChange={(e) => {
                                                    this.handleChangeInputTask(e, index)
                                                }}
                                                value={data.tugas}
                                                validate={{ required: { value: true } }}
                                            />
                                            </div>
                                            <div className="col-md-1 text-right">
                                                {
                                                    index == 0 ? 
                                                    <div className="col-md-2 text-right">
                                                        <Button className="btn-block waves-effect waves-light mb-1 btn btn-dark"
                                                            color="success" 
                                                            type="button"   
                                                            disabled><i className="uil-trash-alt"></i>
                                                        </Button>
                                                    </div> :
                                                        <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                            color="danger" 
                                                            type="button"
                                                            onClick={() => {
                                                                this.delStankom(data)
                                                            }}
                                                            ><i className="uil-trash-alt"></i>
                                                        </Button>
                                                }
                                                
                                            </div>
                                        </div>
                                    )    
                                })
                            }
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>
                                    <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                        color="success" 
                                        type="button"
                                        onClick={this.addTask}
                                        ><i className="uil-plus-circle"></i>Tambah
                                    </Button>
                                    </td>
                                </tr>
                            </tfoot>
                        </Table>
                        <AvField
                            name="position_uuid"
                            type="hidden"
                            value={this.props.uuid}
                            // validate={{ required: { value: true } }}
                            readOnly={true}
                        />
                        
                    </Row>
                    <Row className="mb-3" style={{padding:'25px'}}>
                        <Col md="3"></Col>
                        <Col md="9">
                            <Link to="/master/syarat_jabatan.html">
                                <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                            </Link>
                            {' '}
                            <Button color="success" type="submit">
                                <i className="uil-arrow-up-right"></i> Simpan Data
                            </Button>
                        </Col>
                    </Row>
                </AvForm>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    null// <Redirect to='/master/syarat_jabatan.html'/>
                : null }
            </Fragment>
        )
    }


}

export default TugasComponent
